const infoArr = [
    {
        title: "香港中银大厦",
        detail: "中银大厦是世界著名建筑师贝聿铭的匠心杰作，1990年正式开幕，建成时是香港最高的建筑。其架构如竹，寓意“节节高升”。",
        detail1: "香港人均GDP逐步提高，回归前香港人均GDP（以名义计算）为19.20万港元，2021年香港人均GDP（以名义计算）为38.71万港元。"
    },
    {
        title: "香港国际金融中心",
        detail: "在香港岛中环金融街8号，矗立着香港著名地标——国际金融中心。它面向维多利亚港，见证了香港在国际经济中经历的深刻变化。",
        detail1: "香港交易所现货股票市场1997年日均成交金额为150亿港元，2021年日均成交金额为1667亿港元。香港交易所2021年IPO集资总额422.97亿美元，居全球第四位。"
    },
    {
        title: "尖沙咀钟楼",
        detail: "在香港维多利亚港景色中，尖沙咀钟楼是不可或缺的一部分。钟楼是当年九广铁路九龙总站建筑群的一部分，建成于1915年。",
        detail1: "截至2021年，香港本地生产总值以名义计算为2.86万亿港元。1997年香港本地生产总值为1.37万亿港元。1997年至2021年，香港本地生产总值年均实质增长2.7%。"
    },
    {
        title: "青马大桥",
        detail: "青马大桥是香港引以为傲的地标建筑，它不但创造了世界最长同类型吊桥的纪录，更于1999年与巴拿马运河、英法海峡隧道及旧金山金门大桥等其他九项工程，并列为“20世纪十大建筑”。",
        detail1: "从1997年年中到2021年年中，香港人口总数从650.21万增至741.31万，25年来增长近百万。香港人口密度是全球最高的地区之一，2021年平均每平方公里有6801人。"
    },
    {
        title: "香港故宫文化博物馆",
        detail: "历经4年筹划，香港故宫文化博物馆定于2022年7月2日开放，故宫将借914件文物赴港展出。博物馆占地约1.3万平方米，楼高7层，设有9个展厅。",
        detail1: "从1997年到2021年，香港的文化、康乐和体育设施数量不断增加：公共图书馆从64间增至82间（含固定和流动），游泳池场馆从32座增至44座，体育馆从74座增至102座，足球场从291个增至317个，儿童游乐场地从596个增至665个。"
    }
];

const imageArr = infoArr.map((info, index) => {

    const numId = index + 1;
    const groupId = `image-${numId}`

    const imgBaseUri = `./puzzleimage/${groupId}`;

    return {
        groupId,
        front: {
            id: `images-pz${2 * numId - 1}`,
            src: `${imgBaseUri}/${numId}-1.png`
        },
        back: {
            ...info,
            id: `images-pz${2 * numId}`,
            src: `${imgBaseUri}/${numId}.jpg`
        }
    };
});

export default {
    EVENT: {
        PUZZLE_SELECT_OPERATION: "PUZZLE_SELECT_OPERATION", // 1: 重选，2：开始
        IMAGE_READY: "IMAGE_READY",
        END_OPERATION: "END_OPERATION", // 1: 时间到， 2: 顺利结束
        RULE_DIALOG: "RULE_DIALOG"
    },
    ANIMATE: {
        ANIMATED: "animate__animated",
        TADA: "animate__tada",
        FADE_OUT: "animate__fadeOut",
        FLIP_IN_Y: "animate__flipInY"
    },
    TIME: {
        ONE_SEC: 1000,
        MAX_TIME_ALLOWED: 100
    },
    STYLE: {
        NONE: "none",
        EMPTY_STRING: ""
    },
    ENUM: {
        END_OPERATION: {
            TIME_OUT: 1,
            SUCCESS: 2
        },
        PUZZLE_SELECT_OPERATION: {
            RE_SELECT: 1,
            START_GAME: 2
        },
        RULE_DIALOG: {
            OPEN: 1,
            CLOSE: 2
        }
    },
    STORE: {
        MUTATION: {
            FLIP: "flip"
        }
    },
    REQUEST: {
        ROOT: "https://m.21jingji.com/index.php/ts",
        ADD: "/add"
    },
    KEY: {
        HONGKONG: "hongkong"
    },
    OTHERS: {
        imageArr
    }
};